import * as React from 'react';
import { Component } from 'react';
import { IEducation } from '../../models/IEducation';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import { EducationService } from '../../services/EducationService';
import { LoaderComponent } from '../../controls/Loader';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { ShowStatusBar } from '../Layout/GlobalStatusBar';

interface IProps {
    IsEditMode: boolean,
    Education: IEducation[],
    OnRefreshRequired: () => void
}

interface IState extends IEducation {
    ShowAddNewSection: boolean,
    LoaderVisible: boolean
}

export class EducationComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            ShowAddNewSection: false,
            CollageName: '',
            Id: 0,
            LoaderVisible: false
        }

        this.OnAddNewEducationClick = this.OnAddNewEducationClick.bind(this);
        this.OnInputChange = this.OnInputChange.bind(this);
        this.OnSubmit = this.OnSubmit.bind(this);
        this.GetCollageNameValidationState = this.GetCollageNameValidationState.bind(this);
        this.GetFieldOfStudyValidationState = this.GetFieldOfStudyValidationState.bind(this);
        this.OnSaveSuccess = this.OnSaveSuccess.bind(this);
        this.OnSaveError = this.OnSaveError.bind(this);
        this.OnDeleteSuccess = this.OnDeleteSuccess.bind(this);
        this.OnDeleteError = this.OnDeleteError.bind(this);
        this.OnAbort = this.OnAbort.bind(this);
        this.OnEditClick = this.OnEditClick.bind(this);
    }

    public componentWillReceiveProps(nextProps: IProps) {
        this.setState({
            LoaderVisible: false
        });
    }

    public render() {
        let itemsElement: null | JSX.Element = null;
        let buttons: null | JSX.Element = null;

        if (this.state.ShowAddNewSection) {
            buttons = (
                <div className="buttons">
                    <button className="std-secondary-btn" onClick={this.OnAbort}>Anuluj</button>
                    <button type="submit" className="std-primary-btn">Zapisz</button>
                </div>
            );
            itemsElement = (
                <div className="input">
                    <form onSubmit={this.OnSubmit}>
                        <FormGroup validationState={this.GetCollageNameValidationState()}>
                            <ControlLabel>Uczelnia:</ControlLabel>
                            <FormControl name="CollageName" type="text" value={this.state.CollageName} onChange={this.OnInputChange} />
                            <FormControl.Feedback />
                            <HelpBlock>Podaj nazwę uczelni</HelpBlock>
                        </FormGroup>
                        <FormGroup validationState={this.GetFieldOfStudyValidationState()}>
                            <ControlLabel>Kierunek studiów</ControlLabel>
                            <FormControl name="FieldOfStudy" type="text" value={this.state.FieldOfStudy} onChange={this.OnInputChange} />
                            <FormControl.Feedback />
                            <HelpBlock>Podaj kierunek studiów</HelpBlock>
                        </FormGroup>
                        <FormGroup validationState={this.GetAcademicTitleValidationState()} >
                            <ControlLabel>Tytuł zawodowy / Tytuł naukowy / Stopień naukowy</ControlLabel>
                            <FormControl name="AcademicTitle" type="text" value={this.state.AcademicTitle} onChange={this.OnInputChange} />
                            <FormControl.Feedback />
                            <HelpBlock>Podaj tytuł uzyskiwany po ukończeniu studiów</HelpBlock>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Rok rozpoczęcia studiów</ControlLabel>
                            <FormControl name="StartYear" type="number" value={this.state.StartYear} onChange={this.OnInputChange} />
                            <FormControl.Feedback />
                            <HelpBlock>Podaj rok rozpoczęcia studiów</HelpBlock>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Rok zakończenia studiów</ControlLabel>
                            <FormControl name="EndYear" type="number" value={this.state.EndYear} onChange={this.OnInputChange} />
                            <FormControl.Feedback />
                            <HelpBlock>Podaj rok zakończenia studiów</HelpBlock>
                        </FormGroup>
                        {buttons}
                    </form>
                </div>
            );
        } else {
            if (this.props.IsEditMode) {
                buttons = (
                    <div className="buttons">
                        <a onClick={this.OnAddNewEducationClick}>Dodaj wykształcenie</a>
                    </div>
                );
            }
            let items = this.props.Education.map((edu) => (
                <li key={edu.Id}>
                    <div>
                        <span className="collage-name"><b>{edu.CollageName}</b></span>
                        <span className="field-of-study">
                            <b className="no-bold">
                                {
                                    edu.FieldOfStudy !== null && edu.AcademicTitle !== null ?
                                        (edu.FieldOfStudy + ', ' + edu.AcademicTitle) :
                                        (
                                            edu.FieldOfStudy !== null ? edu.FieldOfStudy : '' +
                                                edu.AcademicTitle !== null ? edu.AcademicTitle : ''
                                        )
                                }
                            </b>
                        </span>
                        {
                            edu.StartYear !== null && edu.EndYear !== null ?
                                (<span>{edu.StartYear + ' - ' + edu.EndYear}</span>) :
                                (
                                    edu.StartYear !== null && edu.EndYear === null ?
                                        (<span>{edu.StartYear + ' - w trakcie'}</span>) :
                                        null
                                )
                        }
                    </div>
                    {
                        this.props.IsEditMode ?
                            (
                                <div className="education-options">
                                    <span className="edit-btn" onClick={this.OnEditClick.bind(this, edu)} />
                                    <span className="delete-btn" onClick={this.OnDeleteClick.bind(this, edu.Id)} />
                                </div>
                            ) :
                            null
                    }
                </li>
            ));
            itemsElement = (
                <div className="education-input">
                    <LoaderComponent Visible={this.state.LoaderVisible} />
                    {
                        items.length ?
                            (<ul>
                                {items}
                            </ul>) :
                            null
                    }
                    {buttons}
                </div>
            );
        }

        return (
            <div className="form-row education-list">
                <label>Wykształcenie:</label>
                {itemsElement}
            </div>
        );
    }//end-of-render
    
    private OnSubmit(evt) {
        if (this.GetCollageNameValidationState() === 'success' &&
            this.GetFieldOfStudyValidationState() === 'success' &&
            this.GetAcademicTitleValidationState() === 'success'
        ) {
            this.setState({
                ShowAddNewSection: false,
                LoaderVisible: true
            });
            let service = new EducationService();
            if (this.state.Id === 0) {
                service.AddMyEducation({
                    CollageName: this.state.CollageName,
                    FieldOfStudy: this.state.FieldOfStudy,
                    AcademicTitle: this.state.AcademicTitle,
                    StartYear: this.state.StartYear,
                    EndYear: this.state.EndYear,
                    Id: this.state.Id
                }, this.OnSaveSuccess, this.OnSaveError);
            } else {
                service.EditMyEducation({
                    CollageName: this.state.CollageName,
                    FieldOfStudy: this.state.FieldOfStudy,
                    AcademicTitle: this.state.AcademicTitle,
                    StartYear: this.state.StartYear,
                    EndYear: this.state.EndYear,
                    Id: this.state.Id
                }, this.OnSaveSuccess, this.OnSaveError);
            }
        }
        evt.preventDefault();
    }

    private OnSaveSuccess(result) {
        this.props.OnRefreshRequired();
        ShowStatusBar('Success', 'Sekcja "Edukacja" zaktualizowana', DEFAULT_STATUS_TIMEOUT);
    }

    private OnSaveError(error) {
        console.error(error);
        this.setState({
            LoaderVisible: false
        });
        ShowStatusBar('Error', 'Nie udało się zaktualizować sekcji "Edukacja". Spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
    }

    private OnDeleteClick(id: number, evt) {
        this.setState({
            LoaderVisible: true
        });
        let service = new EducationService();
        service.RemoveMyEducation(id, this.OnDeleteSuccess, this.OnDeleteError);
    }

    private OnDeleteSuccess(result) {
        this.props.OnRefreshRequired();
        ShowStatusBar('Success', 'Edukacja usunięta', DEFAULT_STATUS_TIMEOUT);
    }

    private OnDeleteError(error) {
        console.error(error);
        this.setState({
            LoaderVisible: false
        });
        ShowStatusBar('Error', 'Nie udało się usunąć edukacji. Spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
    }

    private OnAddNewEducationClick(evt) {
        this.setState({
            ShowAddNewSection: true,
            Id: 0,
            CollageName: '',
            FieldOfStudy: undefined,
            StartYear: undefined,
            EndYear: undefined,
            AcademicTitle: undefined
        });
    }

    private OnInputChange(event) {
        let partialState = {};
        partialState[event.target.name] = event.target.value;
        this.setState(partialState);
    }

    private GetCollageNameValidationState(): 'success' | 'warning' | 'error' {
        if (this.state.CollageName.length > 0) {
            return 'success';
        } else {
            return 'error';
        }
    }

    private GetFieldOfStudyValidationState(): 'success' | 'warning' | 'error' {
        if (this.state.FieldOfStudy) {
            if (this.state.FieldOfStudy.length > 0) {
                return 'success';
            } else {
                return 'error';
            }
        } else {
            return 'error';
        }
    }

    private GetAcademicTitleValidationState(): 'success' | 'warning' | 'error' {
        if (this.state.AcademicTitle) {
            if (this.state.AcademicTitle.length > 0) {
                return 'success';
            } else {
                return 'error';
            }
        } else {
            return 'error';
        }
    }

    private OnAbort(evt) {
        this.setState({
            ShowAddNewSection: false,
            Id: 0,
            CollageName: '',
            FieldOfStudy: undefined,
            StartYear: undefined,
            EndYear: undefined,
            AcademicTitle: undefined
        });
    }

    private OnEditClick(edu: IEducation, evt) {
        this.setState({
            ShowAddNewSection: true,
            Id: edu.Id,
            CollageName: edu.CollageName,
            AcademicTitle: edu.AcademicTitle,
            EndYear: edu.EndYear,
            StartYear: edu.StartYear,
            FieldOfStudy: edu.FieldOfStudy
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/PhysiotherapistView/Education.tsx